import { Building } from "lucide-react";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";

interface PropertyTypeSelectProps {
  propertyType: string;
  onChange: (type: string) => void;
}

export const PropertyTypeSelect = ({ propertyType, onChange }: PropertyTypeSelectProps) => {
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Building className="h-4 w-4" />
        <label className="text-sm font-medium">Property Types</label>
      </div>
      <Select
        defaultValue={propertyType}
        onValueChange={onChange}
      >
        <SelectTrigger>
          <SelectValue placeholder="Select preferred property type" />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="house">House</SelectItem>
          <SelectItem value="apartment">Apartment</SelectItem>
          <SelectItem value="villa">Villa</SelectItem>
          <SelectItem value="cabin">Cabin</SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
};